
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import Cocktails from './cocktails';
import EventsScreen from './events';
import ListProducts from './ListProducts';
import ColdDrinks from './colddrinks';
import Alcoholic from './alcoholic';
import BottleScreen from './bottle';
import {useTranslation} from 'react-i18next';

function Index({setShowHappy}) { 

    const { change, getInitData } = useRefresh();
    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const [menus, setMenus] = useState([]);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [housedrinks, sethousedrinks] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showColdDrinks, setShowColdDrinks] = useState(false);
    const [showAlcoholic, setShowAlcoholic] = useState(false);
    const [showBottle, setShowBottle] = useState(false);
    const [cocktail, setcoctail] = useState(false);
    const [liquuors, setliquors] = useState(false);
    const [beers, setbeers] = useState(false);
    const [digestivos, setdigestivos] = useState(false);
    const [showDrinks, setShowDrinks] = useState(false);



     useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, [change]);

     useEffect(() => {
            menus.map((item) => {
            if (item.id === 914) {
                sethousedrinks(item);
            }
                
            if (item.id === 916) {
                setcoctail(item);
            }
                
            if (item.id === 917) {
                setliquors(item);
            }
            if (item.id === 915) {
                setbeers(item);
            }
                
                if (item.id === 918) {
                setdigestivos(item);
            }
        });
    }, [menus]);



    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent  goCategories={setshowCategories} showCocktails={ setShowCocktails} showEvents={ setShowEvents} showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy} setShowColdDrinks={setShowColdDrinks}>
                <div style={{padding: '0 20px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <div style={{ width: '100%', marginBottom: 2, position: 'relative' }}>
                        
                        <img
                             onContextMenu={(e) => e.preventDefault()}
                        style={{
                            width: 200,
                            height: 70,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: 10,
                            
                            
                        }}
                        src={require('./assets/logo.png')}
                        />

                        <div onClick={() => {
                            
                        }}>
                            <img
                                src={require(langEng ? './assets/texthousedrinksen.png': './assets/texthousedrinks.png')}
                                onContextMenu={(e) => e.preventDefault()}
                                style={{
                                    width: '100%',
                                    height: 650,
                                    marginTop: 30,
                                    marginBottom: 10,
                                    objectFit: 'contain',
                                    borderRadius: 25,
                                    pointerEvents: 'none',
                                }}
                            />
                        </div>


                        
                    </div>

                </div>

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                {showColdDrinks && <ColdDrinks setShowHappy={setShowColdDrinks} />}
                {showAlcoholic && <Alcoholic setShowHappy={setShowAlcoholic} />}
                {showBottle && <BottleScreen setShowHappy={setShowBottle} />}
                 {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                />}

            </LayoutContent>
        </div>
    );
}
export default Index;